import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMemberStatusQuotingFill = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M11.9089 7.13388C11.8139 7.04555 11.6914 6.99805 11.5639 6.99805C11.5572 6.99805 11.5505 6.99805 11.5447 6.99805C11.408 7.00305 11.283 7.06138 11.1914 7.16055L7.59634 11.0831C7.413 11.2889 7.29634 11.5522 7.26467 11.8356L7.17384 12.6847C7.15967 12.8139 7.2255 12.8972 7.2655 12.9347C7.30634 12.9731 7.398 13.0339 7.51967 13.0122L8.34553 12.8747C8.64803 12.8239 8.9272 12.6697 9.13136 12.4422L12.6922 8.55473C12.7864 8.45306 12.8339 8.3239 12.8289 8.18806C12.8239 8.05306 12.7664 7.92723 12.6664 7.83471L11.9089 7.13388Z"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M13.6117 9.4015L10.0567 13.2815C9.66917 13.714 9.1325 14.0098 8.5525 14.1073H8.55083L7.72667 14.2448C7.63917 14.2598 7.5525 14.2673 7.465 14.2673C7.07417 14.2673 6.69833 14.119 6.40667 13.844C6.05083 13.5082 5.8775 13.0357 5.93083 12.5498L6.02167 11.6998C6.0825 11.1548 6.305 10.6532 6.66833 10.2448L10.2708 6.31399C10.5925 5.96649 11.0267 5.76732 11.4967 5.74899C11.9625 5.73316 12.4142 5.89732 12.7575 6.21649L13.515 6.91732C13.86 7.23649 14.0592 7.67066 14.0783 8.13983C14.0958 8.609 13.93 9.05733 13.6117 9.4015ZM10 2.09066C5.635 2.09066 2.08333 5.64232 2.08333 10.0073C2.08333 14.3723 5.635 17.924 10 17.924C14.365 17.924 17.9167 14.3723 17.9167 10.0073C17.9167 5.64232 14.365 2.09066 10 2.09066Z"
	})]
});
export default SvgMemberStatusQuotingFill;
